module.exports = __webpack_public_path__ + "img/ld_5@2x.bbe989df.png";